<template><section><template>
<h3>时间轴</h3>
<div class="bs-docs-section">
<blockquote>
<p>时间轴（静态）</p>
</blockquote>
<div class="bs-example">
<n3-timeline>
<n3-timeline-item color="#2ecc71" icon="check-circle-o">创建成功</n3-timeline-item>
<n3-timeline-item color="#3498db">通过审核</n3-timeline-item>
<n3-timeline-item color="#e74c3c" icon="times-circle-o">出现异常</n3-timeline-item>
</n3-timeline>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline</span> &gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#2ecc71'</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"check-circle-o"</span>&gt;</span>创建成功<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#3498db'</span>&gt;</span>通过审核<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#e74c3c'</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"times-circle-o"</span>&gt;</span>出现异常<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline</span>&gt;</span>
</code></pre>
<blockquote>
<p>时间轴（数据绑定）</p>
</blockquote>
<div class="bs-example">
<n3-timeline :value="value">
</n3-timeline>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline</span>
  <span class="hljs-attr">:value</span>=<span class="hljs-string">"value"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">value</span>: [{
        <span class="hljs-attr">icon</span>: <span class="hljs-string">'check-circle-o'</span>,
        <span class="hljs-attr">color</span>: <span class="hljs-string">'green'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">`&lt;a @click="del"&gt;创建成功&lt;/a&gt;`</span>
      }, {
        <span class="hljs-attr">content</span>: <span class="hljs-string">'&lt;span&gt;通过审核&lt;/span&gt;'</span>
      }, {
        <span class="hljs-attr">content</span>: <span class="hljs-string">'&lt;span&gt;出现异常&lt;/span&gt;'</span>
      }]
    }
  },
  <span class="hljs-attr">methods</span>: {
    del () {
      alert(<span class="hljs-number">2</span>)
    }
  }
}
</code></pre>
<h3>Timeline参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td><code v-pre="">Array</code></td>
<td></td>
<td>内容数组</td>
</tr>
</tbody>
</table>
<h3>TimelineItem参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>color</td>
<td><code v-pre="">String</code></td>
<td>#2db7f5</td>
<td>颜色</td>
</tr>
<tr>
<td>content</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>内容</td>
</tr>
<tr>
<td>icon</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>自定义图标</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: [{
        icon: 'check-circle-o',
        color: 'green',
        content: `<a @click="del">创建成功</a>`
      }, {
        content: '<span>通过审核</span>'
      }, {
        content: '<span>出现异常</span>'
      }]
    }
  },
  methods: {
    del () {
      alert(2)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TimelineDocs.md?27153be4